/**
 * Azure Regions Configuration
 * Shared regions list used across the application (SLA page, resource configuration, etc.)
 */

export const AZURE_REGIONS = [
  { value: 'germanywestcentral', label: 'Germany West Central', enabled: true },
  { value: 'germanynorth', label: 'Germany North', enabled: false },
  { value: 'westeurope', label: 'West Europe', enabled: false },
  { value: 'northeurope', label: 'North Europe', enabled: false },
  { value: 'eastus', label: 'East US', enabled: false },
  { value: 'eastus2', label: 'East US 2', enabled: false },
  { value: 'westus', label: 'West US', enabled: false },
  { value: 'westus2', label: 'West US 2', enabled: false },
  { value: 'westus3', label: 'West US 3', enabled: false },
  { value: 'centralus', label: 'Central US', enabled: false },
  { value: 'southcentralus', label: 'South Central US', enabled: false },
  { value: 'northcentralus', label: 'North Central US', enabled: false },
  { value: 'canadacentral', label: 'Canada Central', enabled: false },
  { value: 'canadaeast', label: 'Canada East', enabled: false },
  { value: 'uksouth', label: 'UK South', enabled: false },
  { value: 'ukwest', label: 'UK West', enabled: false },
  { value: 'francecentral', label: 'France Central', enabled: false },
  { value: 'francesouth', label: 'France South', enabled: false },
  { value: 'switzerlandnorth', label: 'Switzerland North', enabled: false },
  { value: 'switzerlandwest', label: 'Switzerland West', enabled: false },
  { value: 'italynorth', label: 'Italy North', enabled: false },
  { value: 'norwayeast', label: 'Norway East', enabled: false },
  { value: 'norwaywest', label: 'Norway West', enabled: false },
  { value: 'swedencentral', label: 'Sweden Central', enabled: false },
  { value: 'polandcentral', label: 'Poland Central', enabled: false },
  { value: 'southeastasia', label: 'Southeast Asia', enabled: false },
  { value: 'eastasia', label: 'East Asia', enabled: false },
  { value: 'japaneast', label: 'Japan East', enabled: false },
  { value: 'japanwest', label: 'Japan West', enabled: false },
  { value: 'koreacentral', label: 'Korea Central', enabled: false },
  { value: 'koreasouth', label: 'Korea South', enabled: false },
  { value: 'australiaeast', label: 'Australia East', enabled: false },
  { value: 'australiasoutheast', label: 'Australia Southeast', enabled: false },
  { value: 'australiacentral', label: 'Australia Central', enabled: false },
  { value: 'australiacentral2', label: 'Australia Central 2', enabled: false },
  { value: 'brazilsouth', label: 'Brazil South', enabled: false },
  { value: 'southafricanorth', label: 'South Africa North', enabled: false },
  { value: 'southafricawest', label: 'South Africa West', enabled: false },
  { value: 'uaenorth', label: 'UAE North', enabled: false },
  { value: 'uaecentral', label: 'UAE Central', enabled: false },
  { value: 'indiawest', label: 'India West', enabled: false },
  { value: 'indiacentral', label: 'India Central', enabled: false },
  { value: 'indiasouth', label: 'India South', enabled: false },
];

